<div class="flex-row flex-justify-between" style="margin-bottom: 1rem">
  <div class="flex-row gap-4px">
    <p-input-group>
      <p-inputgroup-addon>
        {{'Chain'|transloco}}
      </p-inputgroup-addon>
      <p-select
        [placeholder]="'Select Chain'|transloco"
        optionLabel="name"
        optionValue="chain_id"
        appendTo="body"
        [filter]="true"
        [showClear]="true"
        [style]="{width: '250px'}"
        [options]="fsvc.form_json.assignedChains"
        [(ngModel)]="asvc.currentChainId"
        (onChange)="getChainAssignment()"
      />
    </p-input-group>

    @if (asvc.currentChainId > 0) {

      <p-input-group>
        <p-inputgroup-addon>
          Branch
        </p-inputgroup-addon>
        <p-select
          placeholder="Select Branch..."
          optionLabel="name"
          optionValue="id"
          appendTo="body"
          [filter]="true"
          [showClear]="true"
          [style]="{width: '250px'}"
          [options]="asvc.cchain.branchesList"
          [(ngModel)]="asvc.currentBranchId"
          (onChange)="getBranchAssignments()"
          [disabled]="asvc.cchain.branchesList.length == 0 || sysvc.branchesLoading()"
        />
      </p-input-group>

        @if (asvc.currentBranchId > 0) {
          @if (!asvc.IsBranchAssigned()) {
            <p-button
              icon="fa-regular fa-plus"
              [style]="{width: '260px'}"
              severity="success"
              [label]="Yii.t('app', 'Create Branch Schedule Settings')"
              (click)="setBranchSettings()"
              />
          }

          @if (asvc.IsBranchAssigned()) {
            <p-button
              icon="fa-regular fa-minus"
              severity="danger"
              [style]="{width: '260px'}"
              [label]="Yii.t('app', 'Unset Branch Schedule Settings')"
              (click)="DeleteBranchSettings()"
              />
          }
        }
    }
  </div>
  <div>
    <p-button [label]="Yii.t('app', 'Assign Chain')" (click)="dialogs.AssignChain()"/>
  </div>
</div>
@if (!asvc.IsChainAssigned()) {
  <p-message severity="info" icon="fa fa-circle-info" size="large">
    {{ Yii.t('app', 'Please, select a chain from the list to set settings') }}
  </p-message>
}
